import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const DashboardHeader = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  console.log("USER in the dashboard:", user);

  const menuLinks = [
    { label: 'Today', path: '/dashboard/today' },
    { label: 'My Kitchens', path: '/dashboard/my-listings' },
    { label: 'Calendar', path: '/dashboard/calendar' },
    { label: 'Messages', path: '/dashboard/messages' },
    { label: 'Menu', path: '/dashboard/menu' },
  ];

  return (
    <Box className="dashboard-header-section" sx={{ py: 4, bgcolor: '#ffffff' }}>
      <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
        <Typography variant="h2" color="text.primary" sx={{ mb: 2 }}>
          Welcome back, {user?.firstName || 'User'}!
        </Typography>
        <Box className="dashboard-menu-bar">
          {menuLinks.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className={`menu-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardHeader;